import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeInUp, staggerContainer } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function WhyFailedSection() {
  return <Section id="why-failed" data-id="element-178">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} className="max-w-4xl mx-auto" data-id="element-179">
        <motion.div variants={fadeInUp} className="text-center mb-12" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-181">
            ¿Por Qué Lo Que Probaste{' '}
            <span className="text-gold-gradient" data-id="element-182">No Funcionó</span>?
          </h2>
          <div className="w-24 h-1 bg-gold-gradient mx-auto" data-id="element-183"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
          {['Porque las fajas genéricas no consideran las curvas ni la firmeza que buscas.', 'Porque no venían con una guía detallada para el uso diario y el mantenimiento.', 'Porque nadie te brindó un apoyo personalizado para responder tus dudas.', 'Porque no eran fajas colombianas originales, con la calidad y confección que hace la diferencia.'].map((reason, index) => <motion.div key={index} variants={fadeInUp} className="bg-dark-900 p-6 rounded-xl border border-gold-dark/20 hover:border-gold-DEFAULT/50 transition-colors duration-300 group" data-id="element-185">
              <div className="flex items-start gap-4" data-id="element-186">
                <div className="bg-dark-800 p-2 rounded-lg group-hover:bg-gold-dark/10 transition-colors" data-id="element-187">
                  <AlertCircle className="w-6 h-6 text-gold-DEFAULT" data-id="element-188" />
                </div>
                <p className="text-gray-300 leading-relaxed" data-id="element-189">{reason}</p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </Section>;
}